import clsx from 'clsx';
import React from 'react';
import PropTypes from 'prop-types';
import { bsClass, getClassSet, splitBsProps } from './utils/bootstrapUtils';
class Badge extends React.Component {
  hasContent(children) {
    let result = false;
    React.Children.forEach(children, child => {
      if (result) {
        return;
      }
      if (child || child === 0) {
        result = true;
      }
    });
    return result;
  }
  render() {
    const {
      pullRight,
      className,
      children,
      ...props
    } = this.props;
    const [bsProps, elementProps] = splitBsProps(props);
    const classes = {
      ...getClassSet(bsProps),
      'pull-right': pullRight,
      // Hack for collapsing on IE8.
      hidden: !this.hasContent(children)
    };
    return /*#__PURE__*/React.createElement("span", Object.assign({}, elementProps, {
      className: clsx(className, classes)
    }), children);
  }
}

// TODO: `pullRight` doesn't belong here. There's no special handling here.

Badge.defaultProps = {
  pullRight: false
};
export default bsClass('badge', Badge);